(function(angular){
	'use strict';

	angular
		.module('changeBankAccountModalModule')
		.controller('ChangeBankAccountModalController', [
			'$filter',
			'$rootScope',
			'$scope',
			'$timeout',
			'changeBankAccountDto',
			'close',
			'INVESTMENT_ENTITY_ID',
			'ignoreClose',
			'mixpanelFactory',
			'urlFactory',
			'PlaidFactory',
			ChangeBankAccountModalFunction
		]);

	function ChangeBankAccountModalFunction(
		$filter,
		$rootScope,
		$scope,
		$timeout,
		changeBankAccountDto,
		close,
		INVESTMENT_ENTITY_ID,
		ignoreClose,
		mixpanelFactory,
		urlFactory,
		PlaidFactory
	) {
		var changeBankAccountModal = this;
		var addNewPlaidAccountId;

		function buildPayload() {
			return {
				bankAccountId: changeBankAccountModal.reitInvestmentBankAccount.id,
				transactionType: 'ACH'
			};
		}

		function isValidSelection() {
			if(changeBankAccountModal.reitInvestmentBankAccount.id === addNewPlaidAccountId){
				return true;
			}
			return $filter('filter')(changeBankAccountModal.validAccountTypes, changeBankAccountModal.reitInvestmentBankAccount.accountType, true).length > 0;
		}

		function validateBankAccountType(){
			var isValid = isValidSelection();
			$scope.changeBankAccountModal.changeBankAccountForm.selectedAccountId.$setValidity("savings", isValid);
			$scope.changeBankAccountModal.changeBankAccountForm.selectedAccountId.$setTouched();
		}

		changeBankAccountModal.onAccountSelection = function(){
			mixpanelFactory.track("Selected Bank Account", changeBankAccountModal.reitInvestmentBankAccount);
			validateBankAccountType();
		};

		function successfullyLinkedPlaidAccount(linkedAccount) {
			var newAccount = {
				label: linkedAccount.label + " (" + linkedAccount.accountType.charAt(0).toUpperCase() + linkedAccount.accountType.slice(1).toLowerCase() + ")",
				id: linkedAccount.id,
				accountType: linkedAccount.accountType
			};
			changeBankAccountModal.reitInvestmentBankAccount = $filter('filter')(changeBankAccountModal.paymentMethodOptions, {'id': newAccount.id}, true)[0];
			if(angular.isUndefined(changeBankAccountModal.reitInvestmentBankAccount)){
				changeBankAccountModal.paymentMethodOptions.unshift(newAccount);
				changeBankAccountModal.reitInvestmentBankAccount = newAccount;
			}
			changeBankAccountModal.formSubmitted = false;
			changeBankAccountModal.onAccountSelection();
		}

		function errorLinkingPlaidAccount() {
			$rootScope.ModalFactory.openDisclaimer('invalid-plaid-account-selected');
			onExitPlaidLink();
		}

		function onExitPlaidLink() {
			$timeout(function(){
				changeBankAccountModal.reitInvestmentBankAccount = changeBankAccountModal.paymentMethodOptions[0];
				changeBankAccountModal.onAccountSelection();
				changeBankAccountModal.formSubmitted = false;
			});
		}

		function submitRequest() {
			var url = "/api-secured/investment-entity/" + INVESTMENT_ENTITY_ID + "/order-group/" + changeBankAccountModal.reitInvestmentOrderGroupId + "/attach-bank-account";
			urlFactory.apiPostPromise(url, buildPayload())
				.then(function(){
					urlFactory.redirect("/account/change-bank-account-success/order-group-id/" + changeBankAccountModal.reitInvestmentOrderGroupId);
				}).catch(function(){
					urlFactory.redirect("/account/change-bank-account-failed/order-group-id/" + changeBankAccountModal.reitInvestmentOrderGroupId);
				});
		}

		changeBankAccountModal.handleContinue = function(){
			if(changeBankAccountModal.reitInvestmentBankAccount.id === addNewPlaidAccountId) {
				PlaidFactory
					.getPlaid(successfullyLinkedPlaidAccount, errorLinkingPlaidAccount, onExitPlaidLink)
					.open();
			}
			else if(changeBankAccountModal.reitInvestmentBankAccount.id === changeBankAccountModal.originalAccountId){
				mixpanelFactory.track("User Exited Modal With Same Bank Account", changeBankAccountModal.reitInvestmentBankAccount);
				changeBankAccountModal.close();
			}
			else{
				submitRequest();
			}

		};

		(function init(){
			addNewPlaidAccountId = '-1';
			angular.extend(changeBankAccountModal, changeBankAccountDto);
			changeBankAccountModal.reitInvestmentBankAccount  = $filter('filter')(changeBankAccountModal.paymentMethodOptions, {'id': changeBankAccountModal.originalAccountId}, true)[0];
			changeBankAccountModal.close = close;
			changeBankAccountModal.ignoreClose = ignoreClose;
			changeBankAccountModal.formSubmitted = false;
		})();

	}

})(window.angular);